<template>
    <v-autocomplete
        ref="field"
        v-model="item"
        :items="items"
        :loading="isLoading"
        hide-no-data
        hide-selected
        item-text="name"
        label="Item"
        placeholder=""
        return-object
        auto-select-first
    >
        <template v-slot:item="item">
            <v-list-item-content>
                <v-list-item-title v-text="item.item.name"></v-list-item-title>
                <!-- <v-list-item-subtitle v-text="item.item.presentation"></v-list-item-subtitle> -->
            </v-list-item-content>

            <v-list-item-action>
                <span>
                    <v-icon>mdi-package-variant-closed</v-icon> {{ item.item.currentStock }}
                </span>
            </v-list-item-action>
        </template>
    </v-autocomplete>
</template>

<script>
    export default {
        components: {},

        props: {
            value: Object
        },

        data() {
            return {
                item: null
            };
        },

        computed: {
            items() {
                return this.$store.getters['inventory/getAll']();
            },

            isLoading() {
                return this.$store.getters['inventory/isLoading']();
            }
        },

        mounted() {

        },

        watch: {
            value(v) {
                this.item = v;
            },

            item(v) {
                this.$emit('input', v);
            }
        },

        methods: {
            focus() {
                this.$refs.field.focus();
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>
